export default __webpack_public_path__ + "static/media/complete.280987ff.svg";